<div class="container-fluid my-4">
  <form [formGroup]="form">
    <!-- TEXTO + CANALES -->
    <p class="text-dark mb-2">
      Autorizo a <strong>Coomeva Medicina Prepagada S.A.</strong> para que me
      contacten por cualquiera de los siguientes canales para realizar
      actividades de cobranza, actividades comerciales y envío de mensajes
      publicitarios, de conformidad con lo establecido en la Ley de Intimidad
      (Ley 2300 de 2023 y en las demás normas que la complementen, modifiquen o
      sustituyan):
    </p>

    <!-- CHECKBOXES INLINE -->
    <div class="d-flex flex-wrap gap-3 text-dark" formGroupName="canales">
      <mat-checkbox
        color="primary"
        formControlName="todos"
        (change)="onCanalChange('todos')"
      >
        Todos los canales
      </mat-checkbox>

      <mat-checkbox
        color="primary"
        formControlName="correo"
        (change)="onCanalChange('correo')"
      >
        Correo electrónico
      </mat-checkbox>

      <mat-checkbox
        color="primary"
        formControlName="redes"
        (change)="onCanalChange('redes')"
      >
        Redes sociales (WhatsApp y otros equivalentes)
      </mat-checkbox>

      <mat-checkbox
        color="primary"
        formControlName="mensaje"
        (change)="onCanalChange('mensaje')"
      >
        Mensaje de texto y multimedia
      </mat-checkbox>

      <mat-checkbox
        color="primary"
        formControlName="telefono"
        (change)="onCanalChange('telefono')"
      >
        Teléfono fijo y celular
      </mat-checkbox>
    </div>

    <!-- ERROR CANALES -->
    <div class="text-danger mt-1" *ngIf="form.get('canales')?.touched && canalesInvalid">
        Debe seleccionar al menos un canal
    </div>

    <br />

    <!-- TEXTO + RADIO INLINE -->
    <p class="text-dark mb-1 d-inline">
      De acuerdo a la selección de canales, autorizo ser contactado por más de
      una ocasión durante el mismo día y el uso de diferentes canales de
      contacto durante la semana:
    </p>

    <mat-radio-group
      formControlName="contactoMultiple"
      color="primary"
      class="d-inline-flex ms-2 gap-3"
    >
      <mat-radio-button [value]="true">Sí</mat-radio-button>
      <mat-radio-button [value]="false">No</mat-radio-button>
    </mat-radio-group>

    <!-- ERROR RADIO -->
    <div class="text-danger mt-1" *ngIf="form.get('contactoMultiple')?.touched && form.get('contactoMultiple')?.invalid">
        Debe seleccionar una opción
    </div>

    <br />

    <!-- TEXTO FINAL -->
    <p class="text-dark mb-0">
      Si los canales seleccionados presentan fallas que imposibiliten su
      utilización o no se logra la contactabilidad, el Titular autoriza a las
      empresas del GECC a utilizar cualquier otro canal.
    </p>
  </form>
</div>
